import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import LoadScript from 'vue-plugin-load-script';

const app = createApp(App).use(store);
app.use(LoadScript);
app.mount('#app');
